import { useSelector } from "react-redux";
import { API_SOURCE } from "../constants/app-constants";
import { PRICE_LABELS } from "../constants/checkout-constants";
import { getAbExpirementVariant } from "../utils/helpers/get-ab-expirement-variant";
import { EXPERIMENT_TYPE } from "../constants/optimize-constants";

const EMPTY_OBJ = {};

const getDefaultPriceLabel = ({ isDealerListing = false, tradeInCase = false }) => {
    if (isDealerListing) {
        return PRICE_LABELS.GOVT_CHARGES_MAY_APPLY_TEXT;
    }
    if (tradeInCase) {
        return PRICE_LABELS.TRADE_IN_PRICE_TEXT;
    }
    return PRICE_LABELS.VEHICLE_PRICE_TEXT;
};

export const useVehicleBasePriceLabel = ({
    source = API_SOURCE.DESKTOP,
    isInternalListing = false,
    isDealerListing = false,
    tradeInCase = false
} = {}) => {
    const abExperiment = useSelector((state) => state?.abExperiment || EMPTY_OBJ);
    const {
        msiteVehicleBasePrice = EMPTY_OBJ,
        desktopVehicleBasePrice = EMPTY_OBJ
    } = abExperiment || EMPTY_OBJ;
    const defaultLabel = getDefaultPriceLabel({ isDealerListing, tradeInCase });
    const vehicleBasePriceExperiment = source === API_SOURCE.M_SITE ? msiteVehicleBasePrice : desktopVehicleBasePrice;
    const isVehicleBasePriceVariant = getAbExpirementVariant(vehicleBasePriceExperiment, EXPERIMENT_TYPE.VARIANT_B);

    if (!isInternalListing || isDealerListing || tradeInCase) {
        return {
            vehiclePriceLabel: defaultLabel,
            isVehicleBasePriceVariant: false
        };
    }

    return {
        vehiclePriceLabel: isVehicleBasePriceVariant ? PRICE_LABELS.EXCL_FEE_AND_GOVT_CHARGES_TEXT : PRICE_LABELS.VEHICLE_PRICE_TEXT,
        isVehicleBasePriceVariant
    };
};

export default useVehicleBasePriceLabel;
